/**
 * 获取差异数组
 * @param parentList: Array
 * @param childrenList: Array
 * @param key: String
 */
export const filterList = (parentList = [], childrenList = [], key = "id") => {
  let arr = [];
  arr = parentList.filter((item) => {
    return childrenList.every((citem) => item[key] !== citem[key]);
  });
  return arr;
};

export const dataTimeFn = (originVal) => {
  if (originVal && originVal != "") {
    var date = new Date();
    date.setTime(originVal * 1000); //时间戳为微秒*1,毫秒*1000
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;
    var h = date.getHours();
    h = h < 10 ? "0" + h : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? "0" + minute : minute;
    second = second < 10 ? "0" + second : second;
    return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
  } else {
    return "";
  }
};

const add0 = (m) => {
  return m < 10 ? "0" + m : m;
};

export const getTime = (shijianchuo) => {
  shijianchuo = parseInt(shijianchuo);
  var time = new Date(shijianchuo);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y + "-" + add0(m) + "-" + add0(d) + " " + add0(h) + ":" + add0(mm) + ":" + add0(s);
};

export const prefix = (item, key) => {
  if (item.createUserName === "system" && key !== "remindingUserName") {
    return "系统";
  }
  if (!item.forwardType) {
    return "";
  }
  if (key === "createUserName") {
    if (item.forwardType == "0") {
      return "客户";
    } else {
      return "平台";
    }
  }
  if (key === "remindingUserName") {
    if (item.createUserName === "system") {
      return "平台";
    }
    if (item.forwardType == "0") {
      return "平台";
    } else {
      return "客户";
    }
  }
};

export const prefixColor = (item, key) => {
  if (item.createUserName === "system" && key !== "remindingUserName") {
    return "#5baa6c";
  }
  if (!item.forwardType) {
    return "";
  }
  if (key === "createUserName") {
    if (item.forwardType == "0") {
      return "#f56c6c";
    } else {
      return "#f59a23";
    }
  }
  if (key === "remindingUserName") {
    if (item.createUserName === "system") {
      return "#f59a23";
    }
    if (item.forwardType == "0") {
      return "#f59a23";
    } else {
      return "#f56c6c";
    }
  }
};
